import API, { TEMPORARY_TOKENS_KEY } from '../api/temporary';
import { ApiRoutes } from '../constans/api';
import { clearStorageItem, getStorageItem, setStorageItem } from '../helpers/helpers';

export interface IJWTTokenResp {
  access: string;
  refresh: string;
}

export const getJWTTokenRequest = async (token: string) => {
  const { login } = ApiRoutes;
  const { data } = await API.post<IJWTTokenResp>(login, { token });

  return data;
};

export const refreshTokenRequest = async () => {
  const { refresh } = getStorageItem<IJWTTokenResp>(TEMPORARY_TOKENS_KEY, 'session') ?? {};

  const { refreshToken } = ApiRoutes;

  try {
    const { data } = await API.post<IJWTTokenResp>(refreshToken, { refresh });

    if (data) {
      setStorageItem(TEMPORARY_TOKENS_KEY, data, 'session');
    }

    return data;
  } catch (error: unknown) {
    clearStorageItem(TEMPORARY_TOKENS_KEY, 'session');
  }
};
